import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import { EllipsisVerticalIcon } from "@heroicons/vue/24/outline";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicMenu',
  props: {
  position: {
    type: String as PropType<"left" | "right" | "center">,
    default: "right",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Menu), {
    as: "div",
    class: "inline-block text-left leading-none relative"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(MenuButton), { class: "flex w-full items-center rounded-full text-gray-500 hover:text-gray-600" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "icon", {}, () => [
            _createVNode(_unref(EllipsisVerticalIcon), {
              class: "h-4 w-4",
              "aria-hidden": "true"
            })
          ])
        ]),
        _: 3
      }),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "transform opacity-0 scale-95",
        "enter-to-class": "transform opacity-100 scale-100",
        "leave-active-class": "transition ease-in duration-75",
        "leave-from-class": "transform opacity-100 scale-100",
        "leave-to-class": "transform opacity-0 scale-95"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(MenuItems), {
            class: _normalizeClass([
          'absolute z-50 mt-3 whitespace-nowrap overflow-hidden rounded-md bg-white shadow-lg focus:outline-none py-2 text-sm',
          __props.position === 'left' && 'right-0',
          __props.position === 'center' && 'left-1/2 -translate-x-1/2',
          __props.position === 'right' && 'left-0',
        ])
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "content", { item: _unref(MenuItem) })
            ]),
            _: 3
          }, 8, ["class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})